import { AuthState, Mutations, Actions } from "@/types/entities.ts";
import { Auth } from "aws-amplify";

const state: AuthState = {
  authorization: false,
  loginUserInfo: {
    name: "",
    email: "",
    password: "",
  },
};

const getters = {};

const mutations: Mutations = {
  signin: (state, userInfo) => {
    state.authorization = true;
    state.loginUserInfo = userInfo;
  },

  setUserAttribute: (state, attributes) => {
    state.loginUserInfo.attributes = attributes;
  },

  logout: (state, userInfo) => {
    state.authorization = false;
    state.loginUserInfo = {};
    // all data should be cleared
  },
};

const actions: Actions = {

  alreadySignedIn: ({commit}, user) => {
    commit("signin", user);
  },

  signin: ({commit}, credentials) => {
    return new Promise( async (resolve, reject) => {
      let nextProps = {
        path: "",
        status: "",
      };
      try {
        const { username, password } = credentials;
        const user = await Auth.signIn(username, password);

        if (user.challengeName === "SMS_MFA" || user.challengeName === "SOFTWARE_TOKEN_MFA") {
          // MFA は使わないのでここは通らない
          nextProps = { path: "verify-code", status: `isWatingCode:${user.challengeName}` };
        } else if (user.challengeName === "UNCONFIRMED") {
          nextProps = { path: "change-password", status: "done" };
        } else if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          // 新規にユーザ作成したときの初回アクセス。必ずパスワード変更にんすｒ
          nextProps = { path: "new-password", status: "done" };
        } else if (user.challengeName === "MFA_SETUP") {
          // MFA は使わないのでここは通らない
          Auth.setupTOTP(user);
        } else {
          nextProps = { path: "", status: "done" }; // TODO: redirect path
        }
        commit("signin", user);
        resolve(nextProps);
      } catch (error) {
        console.log("login failed", error);
        if (error.code === "UserNotConfirmedException") {
          // 検証コードを入力する作業が完了していないユーザーがサインインしようとした時。
          // ユーザ作成が画面からないならここに来ることはない
        } else if (error.code === "PasswordResetRequiredException") {
          alert(`管理者によってパスワードがリセットされました。パスワード再設定を行ってください。: ${error.message}`);
          // パスワード忘れと同様の処理
          nextProps = { path: "new-password", status: "done" };
        } else if (error.code === "UserNotFoundException" || error.code === "NotAuthorizedException") {
          // ユーザがいないかどうかは伝えないようにする。いなくても入力ミスでも同じでエラーにする
          reject(`アドレスもしくはパスワードが正しくありません`);
          return;
        }
        resolve(nextProps);
      }
    });
  },

  changePassword: ({commit, state}, passwordInfo) => {
    return new Promise( async (resolve, reject) => {
      const { loginUserInfo } = state;
      try {
        const result = await Auth.changePassword(
          loginUserInfo,
          passwordInfo.currentPassword,
          passwordInfo.newPassword);
        console.log(`change password is succeeded: ${result}`);
        resolve(result);
      } catch (error) {
        console.log(`change password is failed: ${error.code}`);
        if (error.code === "NotAuthorizedException") {
          reject(`パスワードが正しくありません。`);
        } else {
          reject(`${error.message}`);
        }
      }
    });
  },

  resetPassword: ({commit, state}, newPassword) => {
    return new Promise( async (resolve, reject) => {
      const { loginUserInfo } = state;
      try {
        const {challengeParam} = loginUserInfo;
        if (!challengeParam) {
          reject("unexpected error");
        }
        const result = await Auth.completeNewPassword(
          loginUserInfo,
          newPassword,
          challengeParam.requiredAttributes);
        console.log(`reset password is succeeded: ${result}`);
        resolve(result);
      } catch (err) {
        console.log(`reset password is failed: ${err.message}`);
        reject(err);
      }
    });
  },

  verifyMFACode: ({commit, state}, code) => {
    return new Promise( async (resolve, reject) => {
      const { username } = state.loginUserInfo;
      const result = await Auth.confirmSignUp(username, code);
      console.log(result);
      resolve(result);
    });
  },

  forgotPassword: ({commit, state}, username) => {
    return new Promise((resolve, reject) => {
      Auth.forgotPassword(username)
      .then((data) => console.log(data))
      .catch((err) => console.log(err));
    });
  },

  logout: ({commit}) => {
    return new Promise((resolve, reject) => {
      Auth.signOut()
      .then((data) => {
        console.log(data);
        commit("logout");
        resolve(data);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
    });
  },

  changeEmail: ({commit, state}, email) => {
    return new Promise( async (resolve, reject) => {
      try {
        const { loginUserInfo } = state;
        const result = await Auth.updateUserAttributes(loginUserInfo, { email });
        console.log(result);
        resolve(result);
      } catch (err) {
        reject(err.message);
      }
    });
  },

  verifyEmail: ({commit}, code) => {
    return new Promise( async (resolve, reject) => {
      try {
        const result = await Auth.verifyCurrentUserAttributeSubmit("email", code);
        console.log(result);
        resolve(result);
      } catch (err) {
        reject(err.message);
      }
    });
  },

  /*
  currentAuthenticatedUser: ({commit}) => {
    return new Promise((resolve, reject) => {
      Auth.currentAuthenticatedUser()
      .then((user) => {
        console.log(user);
        commit("setUserAttributes");
        resolve(user);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
    });
  },
  */
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
